import {
  GETWALLETTRANSACTIONLIST_SUCCESS,
  GETWALLETTRANSACTIONLIST_FAILED,
  RESET_GETWALLETTRANSACTIONLIST,
  LOADING_GETWALLETTRANSACTIONLIST,
  NETWORK_ERROR_GETWALLETTRANSACTIONLIST,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  nvalidRequest: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETWALLETTRANSACTIONLIST: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case GETWALLETTRANSACTIONLIST_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case GETWALLETTRANSACTIONLIST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }

    case RESET_GETWALLETTRANSACTIONLIST: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
